import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'pencePer' })
export class PencePerPipe implements PipeTransform {
    transform(value: number, duration = '') {
        return `${value} per ${duration}`;
    }
}